"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isStringArray = exports.isNumberArray = exports.isArray = exports.isObject = exports.isBool = exports.isNumber = exports.isISODateString = exports.isNonEmptyString = exports.isString = exports.optional = void 0;
exports.isType = isType;
const env_1 = require("../utils/env");
function isType(obj, ruleSet) {
  if (!obj) {
    if ((0, env_1.getDebugEnabled)()) {
      console.debug('============ Failed Typeguard ==============');
      console.debug('Object is null or undefined');
    }
    return false;
  }
  const failedKeys = Object.keys(ruleSet).filter(key => !ruleSet[key](obj[key]));
  if (failedKeys.length === 0) {
    return true;
  }
  if ((0, env_1.getDebugEnabled)()) {
    console.debug('============ Failed Typeguard ==============');
    console.debug(`Object: ${JSON.stringify(obj)}`);
    console.debug('');
    console.debug('============== Failed Keys =================');
    failedKeys.forEach(key => {
      console.debug(`Value for key did not match rule: [${key}: ${JSON.stringify(obj[key])}]`);
    });
    console.debug('');
  }
  return false;
}
const optional = isValidValue => value => value == null ? true : isValidValue(value);
exports.optional = optional;
const isString = value => typeof value === 'string';
exports.isString = isString;
const isNonEmptyString = value => !!value && typeof value === 'string';
exports.isNonEmptyString = isNonEmptyString;
const isISODateString = value => typeof value === 'string' && /\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z)/.test(value);
exports.isISODateString = isISODateString;
const isNumber = value => typeof value === 'number';
exports.isNumber = isNumber;
const isBool = value => typeof value === 'boolean';
exports.isBool = isBool;
const isObject = value => typeof value === 'object';
exports.isObject = isObject;
const isArray = value => Array.isArray(value);
exports.isArray = isArray;
const isNumberArray = value => Array.isArray(value) && value.every(exports.isNumber);
exports.isNumberArray = isNumberArray;
const isStringArray = value => Array.isArray(value) && value.every(exports.isNonEmptyString);
exports.isStringArray = isStringArray;